import React from 'react';
import { HandOverDeviceModal } from './HandOverDeviceModal';
import type { useInPersonSigning } from './use-in-person-signing';

interface IProps {
  signing: ReturnType<typeof useInPersonSigning>;
}

/**
 * Renders the hand-over confirmation whenever a signer is waiting on one. Every
 * entry point drops this in rather than wiring the modal itself.
 */
export function HandOverDeviceFlow({ signing }: IProps) {
  if (!signing.pendingHandOff) return null;

  return (
    <HandOverDeviceModal
      signer={signing.pendingHandOff}
      isStarting={signing.isStarting}
      error={signing.error}
      onConfirm={signing.confirmHandOff}
      onCancel={signing.cancelHandOff}
    />
  );
}
